import React, { useEffect, useState, useRef } from 'react';
//import { useNavigate } from "react-router-dom";
import NitroButton from './parts/NitroButton';
import Matter from 'matter-js'
import ping from '../sounds/Ping-2.mp3';

// inspired by https://paulie.dev/posts/2020/08/react-hooks-and-matter-js/

const STATIC_DENSITY = 12

const Splash = ({qData, setShowSplash}) => {

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()
  const [gravityState, setGravityState] = useState(false)

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
  }

  useEffect(() => {
    let w = window.innerWidth,
    h = window.innerHeight,
    approxFontHeight = w * 0.08,
    topOfTextArea = (h - (5 * approxFontHeight))/2,
    leftOfTextArea = (w-555)/2,
    radius = 20,
    titleFontSize = 124,
    instructionFontSize = 24,
    Engine = Matter.Engine,
    Render = Matter.Render,
    World = Matter.World,
    Bodies = Matter.Bodies,
    Body = Matter.Body,
    Events = Matter.Events,
    MouseConstraint = Matter.MouseConstraint,
    Mouse = Matter.Mouse;

    let engine = Engine.create({})

    let render = Render.create({
      element: boxRef.current,
      engine: engine,
      //canvas: canvasRef.current,
      options: {
        width: w,
        height: h,
        background: 'transparent',
        wireframes: false,
      },
    })

    const floor = Bodies.rectangle(0, 0, 0, STATIC_DENSITY, { isStatic: true })
    const wallLeft = Bodies.rectangle(-200, h / 2, 400, h, { isStatic: true })
    const wallRight = Bodies.rectangle(w + 200, h / 2, 400, h, { isStatic: true })
    const ceiling = Bodies.rectangle(w/2, -200, w, 400, { isStatic: true })

    var textNitro = Bodies.rectangle(leftOfTextArea + ((4.5 * approxFontHeight) / 2), topOfTextArea, 4.5 * approxFontHeight, approxFontHeight, {
      label: 'NITRO',
      render: {
        fillStyle: 'rgba(255,255,255,0)',
        text: { content: 'NITRO', size: titleFontSize }
       }
    })
    var textSurvey = Bodies.rectangle(leftOfTextArea + ((6 * approxFontHeight) / 2), topOfTextArea + approxFontHeight, 6 * approxFontHeight, approxFontHeight, {
      label: 'SURVEY',
      render: {
        fillStyle: 'rgba(255,255,255,0)',
        text: { content: 'SURVEY', size: titleFontSize, color: qData.theme.pageStyle1.textColor }
       }
    })
    var textTool = Bodies.rectangle(leftOfTextArea + ((4 * approxFontHeight) / 2), topOfTextArea + (approxFontHeight * 2.1), 4 * approxFontHeight, approxFontHeight, {
      label: 'TOOL',
      render: {
        fillStyle: 'rgba(255,255,255,0)',
        text: { content: 'TOOL', size: titleFontSize }
       }
    })
    var textInstruction = Bodies.rectangle(leftOfTextArea + (440 / 2), topOfTextArea + (approxFontHeight * 3), 500, 55, {
      label: 'Instruction',
      render: {
        fillStyle: 'transparent',
        text: { content: 'Throw some shapes then press start', size: instructionFontSize, color:  qData.theme.pageStyle1.hint1 }
      }
    })
    var textStart = Bodies.rectangle(leftOfTextArea + (450 / 2), topOfTextArea + (approxFontHeight * 4), 450, 65, {
      label: 'startBtn',
      render: {
        fillStyle: '#FFFFFF',
        text: { content: 'Start', size: 22, color: '#333333' }
      }
    })

    var bigCircleStroke = Matter.Bodies.circle(w/4, 50, 80, {
      render: {
        fillStyle: 'transparent',
        lineWidth: 30,
        strokeStyle: 'white'
      }
    });

    var polygon = Matter.Bodies.polygon(w / 9, h / 7, 6, 80, {
      inertia: Infinity,
      rotationSpeed: 0.001,
      render: { fillStyle: qData.theme.pageStyle1.hint1 } });
    var leftDot = Matter.Bodies.circle(w / 4.5, h / 2, 55, { render: { fillStyle: qData.theme.pageStyle1.hint1 } });
    var leftSquare = Matter.Bodies.rectangle(w / 6, h / 1.5, 70, 70, {
      inertia: Infinity,
      rotationSpeed: 0.001,
      render: { fillStyle: qData.theme.pageStyle1.hint2 } });
    Matter.Body.rotate(leftSquare,-0.2);

    var triangle = Matter.Bodies.polygon(w - (w/6.6), 200, 3, w/15, {
      inertia: Infinity,
      rotationSpeed: 0.002,
      render: { fillStyle: qData.theme.pageStyle1.hint1 } });
    Matter.Body.rotate(triangle, 0.25);

    var rightRect = Matter.Bodies.rectangle(w - (w / 8), h / 3, w / 5, 50, { chamfer: { radius: radius }, render: { fillStyle: qData.theme.pageStyle1.hint2 } });
    Matter.Body.rotate(rightRect, 0.55);

    var rightCircleStroke = Matter.Bodies.circle(w - (w / 5), h/3, 60, {
      render: {
        fillStyle: 'transparent',
        lineWidth: 30,
        strokeStyle: qData.theme.pageStyle1.hint2
      }
    });

    World.add(engine.world, [
      floor, wallLeft, wallRight, ceiling,
      textNitro, textSurvey, textTool, textInstruction, textStart,
      leftSquare,
      triangle,
      polygon,
      rightCircleStroke
    ]);
    Body.setVelocity(leftSquare, { x: 0, y: -1 });
    Body.setVelocity(triangle, { x: 0, y: -1 });

    if (w > 700) {
      World.add(engine.world, [
        bigCircleStroke, leftDot, rightRect
      ]);
      Body.setVelocity(bigCircleStroke, { x: 0, y: 2 });
      Body.setVelocity(polygon, { x: 0, y: -1 });
      Body.setVelocity(leftDot, { x: 0, y: -1 });
      Body.setVelocity(rightRect, { x: 0, y: -1 });
      Body.setVelocity(rightCircleStroke, { x: 0, y: -1 });
    }

    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.5,
          render: {
            visible: false
          }
        }
      });

    World.add(engine.world, mouseConstraint);

    // keep the mouse in sync with rendering
    render.mouse = mouse;

    // Allow page scrolling in matter.js window
    mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
    mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);

    // Detect clicks vs. drags
    let click = false;

    document.addEventListener('mousedown', () => click = true);
    document.addEventListener('mousemove', () => click = false);
    //document.addEventListener('mouseup', () => console.log(click ? 'click' : 'drag'));

    // Create a On-Mouseup Event-Handler
    Events.on(mouseConstraint, 'mouseup', function (event) {
      var mouseConstraint = event.source;
      var bodies = engine.world.bodies;
      var i;
      if (!mouseConstraint.bodyB) {
        for (i = 0; i < bodies.length; i++) {
          var body = bodies[i];
          // Check if clicked or dragged
          if ((body.label === 'startBtn') && (click === true)) {
            if (Matter.Bounds.contains(body.bounds, mouseConstraint.mouse.position)) {
              setGravityState(!gravityState);
              break;
            }
          }
        }
      }
    });

    document.addEventListener("keypress", function (event) {
      if (event.key === "Enter") {
        //event.preventDefault(); // commented out as preventing textarea multi-line
        setGravityState(!gravityState);
      }
    });

    if (gravityState) {

      setTimeout(function () {
        //document.getElementById("splash").classList.add('fadeOut');
        document.getElementById("bomb").classList.add('active');
      }, 900);
      setTimeout(function () {
        //let navigate = useNavigate();
        //navigate("./", { replace: true });
        setShowSplash(false);

      }, 1700);
    }

    function updateRotation() {
      Body.setAngle(polygon, polygon.angle - polygon.rotationSpeed);
      Body.setAngle(triangle, triangle.angle - triangle.rotationSpeed);
      Body.setAngle(leftSquare, leftSquare.angle - leftSquare.rotationSpeed);
      requestAnimationFrame(updateRotation);
    }
    window.requestAnimationFrame(updateRotation);

    Matter.Runner.run(engine)
    Render.run(render)

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [gravityState])

  useEffect(() => {
    if (constraints) {
      let { width, height } = constraints

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

      // Dynamically update floor and walls
      const floor = scene.engine.world.bodies[0],
        wallLeft = scene.engine.world.bodies[1],
        wallRight = scene.engine.world.bodies[2],
        ceiling = scene.engine.world.bodies[3],
        textNitro = scene.engine.world.bodies[4],
        textSurvey = scene.engine.world.bodies[5],
        textTool = scene.engine.world.bodies[6],
        textInstruction = scene.engine.world.bodies[7]

      textNitro.render.text.size = width * 0.1
      textSurvey.render.text.size = width * 0.1
      textTool.render.text.size = width * 0.1
      if (width < 600) {
        textInstruction.render.text.size = width * 0.04
      }

      Matter.Body.setPosition(floor, {
        x: width / 2,
        y: height + STATIC_DENSITY / 2,
      })

      Matter.Body.setPosition(wallLeft, {
        x: -200,
        y: height / 2,
      })

      Matter.Body.setPosition(wallRight, {
        x: width + 200,
        y: height / 2,
      })

      Matter.Body.setVertices(floor, [
        { x: 0, y: height },
        { x: width, y: height },
        { x: width, y: height + STATIC_DENSITY },
        { x: 0, y: height + STATIC_DENSITY },
      ])
    }
  }, [scene, constraints, gravityState])

  useEffect(() => {
    if (scene) {
      //scene.engine.world.gravity.y = (gravityState) ? 1 : 0.001;
      scene.engine.world.gravity.y = (gravityState) ? 1 : 0;

      if (!gravityState) {
        Matter.Events.on(scene.engine, 'collisionStart', function (event) {
          for (var i = 0; i < event.pairs.length; i++) {
            var pair = event.pairs[i];
            if (pair.collision.collided) {
              let audio = new Audio(ping);
              audio.volume = 0.1;
              audio.play();
            }
          }
        });
      } else {
        Matter.Events.off(scene.engine, 'collisionStart')
      }
    }
  }, [scene, gravityState])


  return (

    <div className="w-screen min-h-screen bg-pageStyle1-main" id="splash">
      <div id="bomb"></div>
      <div ref={boxRef} className="splash w-screen h-screen absolute top-0 left-0"></div>
    </div>

  );

}

export default Splash;
